import { enablePatches } from 'immer';

enablePatches();
